import { toTitleCase, wrapQuotes } from "./helpers";

export const mapReasonCodeToTitle = (reasonCode: string) =>
  toTitleCase(reasonCode.split("-").join(" "));

// When a `Flag Note` is set in the system, the backend sets the `Order Note` with its value
// As such `Flag Note` and `Order Note` live in 2 different places, but are the same value 99.99999% of the time.

// It is possible to set a `Flag Note` and then edit the resulting `Order Note`
// In this scenario, an Order would have 2 distinct notes.

// This function Accepts both notes, Dedupes and Filters, and then outputs an array that contains Both notes if they
// are out of sync, a single note if they are equal, or empty array of both are null.
export const normalizeOrderNotes = (
  orderNote?: string | null,
  flagNote?: string | null
): string[] => {
  // Note Labels are used in the case where 2 separate Notes exist
  const noteLabels = ["Order", "Flag"];

  return [...new Set([orderNote, flagNote].filter(Boolean))].map(
    (note, i, arr) =>
      arr.length > 1
        ? `${noteLabels[i]} Note: ${wrapQuotes(note)}`
        : wrapQuotes(note)
  );
};
